<template>
  <el-dialog :visible.sync="dialogVisible" width="100%" class="advertDialog" :show-close="false" @opened="openedHandler"
    @close="dialogCloseHandle">
    <template slot="title">
      <div class="top">
        <img v-if="langFlag" src="@/assets/images/goodsTile.png" alt="">
        <img v-else src="@/assets/images/goodsTileEn.png" alt="">
        <!--        <commonLocation-->
        <!--          ref="advertDialogLocation"-->
        <!--          v-show="!locationManagementFlage && !shoppingCarFlage"-->
        <!--          @addressChange="addressChange"-->
        <!--        />-->
        <headerAddress v-show="!locationManagementFlage && !shoppingCarFlage" ref="advertDialogAddress"
          @addressChange="addressChange" />
        <span class="back" @click="backHandler">
          <i class="iconfont icon-fanhui-icon" />{{ $t('btn.Return') }}
        </span>
        <span class="locationManagement" v-show="!locationManagementFlage && !shoppingCarFlage"
          @click="locationManagementHandler">
          <i class="iconfont icon-guanli-icon" />{{ $t('newApp.ADList.AddMana') }}
        </span>
      </div>
    </template>
    <locationManagement v-show="locationManagementFlage" :location-management-visible="locationManagementFlage" />
    <goodsList ref="goodsList" v-show="!shoppingCarFlage && !locationManagementFlage"
      @shoppingCartSwitch="shoppingCartSwitch" @addShoopingCart="addShoopingCart" :total-num="totalNum" />
    <shoppingCart ref="shoppingCart" v-show="shoppingCarFlage && !locationManagementFlage"
      :shopping-cart-data="shoppingCartData" @totalMoneyCount="totalMoneyCount" />
    <div slot="footer" class="advertDialogFooter" v-show="shoppingCarFlage">
      <div class="wrapper clear">
        <div class="btnBar">
          <el-button type="primary" @click="submitHandle">{{ $t('btn.OK') }}</el-button>
          <el-button plain @click="closeShoppingCart" style="width: 140px;">{{ $t('newApp.ADList.ctc') }}</el-button>
        </div>
        <div class="priceTotal">
          {{ $t('newApp.ADList.Total') }}：
          <span>￥{{ totalMoney }}</span>
        </div>
        <div class="goodsTotal">{{ $t('newApp.ADList.gong') }}<span>{{ shoppingCartData.length }}</span>{{ $t('newApp.ADList.atoxxa') }}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import goodsList from './goodsList';
import shoppingCart from './shoppingCart';
import locationManagement from './locationManagement';
import headerAddress from './headerAddress';
// import commonLocation from '@/components/commonLocation';

export default {
  data() {
    return {
      dialogVisible: false,
      totalMoney: 0,
      shoppingCarFlage: false,
      shoppingCartData: [],
      totalNum: 0, // 商品总数量
      locationManagementFlage: false,
      langFlag: localStorage.getItem('lang') === "zh-CN"
    };
  },
  props: {
    advertDialogVisible: {
      type: Boolean,
      default: false
    },
    currentRow: {
      type: Object,
      default: () => {
        return {};
      }
    },
    carFlageShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    advertDialogVisible(val) {
      if (val) {
        if (this.currentRow.advertiseExpenseDetails && this.currentRow.advertiseExpenseDetails.advertiseOrderDetails.length > 0) {
          this.shoppingCartData = this.currentRow.advertiseExpenseDetails.advertiseOrderDetails;
          this.$nextTick(() => {
            this.$refs.shoppingCart.setDefaultVal(this.currentRow.advertiseExpenseDetails);
          });
          this.totalMoneyCount();
        }
        this.totalNumCount();
        this.shoppingCartSwitch(this.carFlageShow);
        this.$nextTick(() => {
          this.$refs.advertDialogAddress.getDefaultAddress();
        });
      }
      this.dialogVisible = val;
    }
  },
  components: {
    goodsList,
    shoppingCart,
    // commonLocation,
    locationManagement,
    headerAddress
  },
  methods: {
    backHandler() {
      if (this.locationManagementFlage) {
        this.locationManagementBack();
      } else if (this.shoppingCarFlage) {
        this.shoppingCarFlage = false;
      } else {
        this.dialogCloseHandle();
      }
    },
    addressChange() {
      this.$refs.goodsList.getGiftList();
    },
    openedHandler() {
      // this.$refs.advertDialogLocation.mouseenterStartFlag = true;
    },
    locationManagementBack() {
      // this.$refs.advertDialogLocation.getDefaultAddress();
      this.$refs.advertDialogAddress.getDefaultAddress();
      this.locationManagementFlage = false;
    },
    locationManagementHandler() {
      this.locationManagementFlage = true;
    },
    closeShoppingCart() {
      this.shoppingCarFlage = false;
      this.totalNumCount();
    },
    totalNumCount() {
      if (this.shoppingCartData.length > 0) {
        this.totalNum = this.shoppingCartData.reduce((current, item) => {
          return current + Number(item.amount);
        }, 0);
      } else {
        this.totalNum = 0;
      }
    },
    totalMoneyCount() {
      let totalMoney = this.shoppingCartData.reduce((current, item) => {
        let subtotal = Number(item.price) * Number(item.amount);
        return current + Number(subtotal);
      }, 0);
      this.totalMoney = totalMoney.toFixed(2);
    },
    addVerification(item, addNum) {
      // 验证商品是否还有货
      let futureTotal = Number(item.amount) + Number(addNum);
      if (futureTotal > item.stkNum) {
        return false;
      } else {
        return true;
      }
    },
    addShoopingCart(val) {
      for (let i = 0; i < this.shoppingCartData.length; i++) {
        if (this.shoppingCartData[i].giftCode === val.giftCode) {
          if (this.addVerification(this.shoppingCartData[i], val.addNum)) {
            this.shoppingCartData[i].amount = Number(this.shoppingCartData[i].amount) + Number(val.addNum);
            this.totalNumCount();
            this.$message.success(this.$t('general.AddSucc'));
            return;
          } else {
            this.$message.error(this.$t('newApp.ADList.csbii'));
            return;
          }
        }
      }
      let temporaryData = JSON.parse(JSON.stringify(val));
      temporaryData.amount = 0;
      if (!this.addVerification(temporaryData, val.addNum)) {
        this.$message.error(this.$t('newApp.ADList.csbii'));
        return;
      }
      this.shoppingCartData.push({
        ...val,
        shipmentState: this.$t('general.SetupSucc'), // 暂时新增发运方式字段，地址类型确定后在选择删除还是保留
        amount: val.addNum,
        giftCode: val.giftCode,
        giftName: val.giftName,
        giftCoverUrl: val.imgUrl
      });
      this.totalNumCount();
      this.$message.success(this.$t('general.AddSucc'));
    },
    shoppingCartSwitch(val) {
      if (val) {
        if (this.shoppingCartData.length < 1) {
          this.$message.error(this.$t('newApp.ADList.psap'));
        } else {
          this.shoppingCarFlage = val;
          this.totalMoneyCount();
          this.$nextTick(() => {
            this.$refs.shoppingCart.getAddressList();
            this.$refs.shoppingCart.loadTable();
          });
        }
      }
    },
    dialogCloseHandle() {
      this.$emit('dialogCloseHandle');
      this.shoppingCarFlage = false;
      this.shoppingCartData = [];
      this.$refs.shoppingCart.clearFormData();
    },
    submitHandle() {
      let shoppingCartData = this.$refs.shoppingCart.getFormData();
      let returnVal = {
        total: this.totalMoney,
        formData: shoppingCartData
      };
      returnVal.goodsList = this.shoppingCartData.map(item => {
        // 空图片会以base64格式作为url，这里给其清空掉
        if (item.giftCoverUrl.indexOf('data:image/png;base64') === 0) {
          item.giftCoverUrl = '';
          item.imgUrl = '';
        }
        if (!shoppingCartData.countryType) {
          delete item.shipmentState;
        }
        return item;
      });
      this.$emit('submitHandle', returnVal);
      this.shoppingCarFlage = false;
      this.shoppingCartData = [];
      this.$refs.shoppingCart.clearFormData();
    }
  }
};
</script>

<style lang="scss" scoped>
.advertDialog {
  ::v-deep>.el-dialog {
    margin: 0 !important;
    min-height: 100%;
    position: relative;
    background: #e9ecf1;

    .el-dialog__header {
      padding: 0;

      >.top {
        padding: 0 200px;
        background: #313D4A;
        line-height: 50px;
        height: 50px;

        &:after {
          content: '';
          display: block;
          clear: both;
        }

        >img {
          float: left;
          position: relative;
          top: 50%;
          margin-top: -8.5px;
        }

        >.headerAddress {
          float: left;
          margin-left: 60px;
        }

        >span {
          float: right;
          color: #FFFFFF;
          font-size: 16px;
          cursor: pointer;

          >i {
            margin-right: 8px;
          }
        }

        >.locationManagement {
          margin-right: 40px;
        }
      }
    }

    .el-dialog__body {
      height: 100%;
      padding: 0;
    }

    .el-dialog__footer {
      width: 100%;
      overflow: hidden;

      .advertDialogFooter {
        width: 100%;
        height: 60px;
        background: #ffffff;
        line-height: 60px;
        box-shadow: 0px -5px 6px 0px rgba(42, 47, 46, 0.04);
        position: fixed;
        bottom: 0;
        z-index: 100;

        >.wrapper {
          width: 1200px;
          margin: 0 auto;

          >div {
            float: right;
            margin-left: 60px;
            font-size: 16px;
          }

          >.goodsTotal {
            color: #354052;

            >span {
              color: #14937B;
              font-weight: bold;
            }
          }

          >.priceTotal {
            color: #354052;

            >span {
              color: #17A58A;
              font-weight: bold;
            }
          }

          >.btnBar {
            >.el-button {
              width: 120px;
              height: 40px;
              line-height: 40px;
              padding: 0 !important;
            }

            >button+button {
              margin-left: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
